import React from 'react'
import { Col, Divider, Flex, Row, Space, Typography } from 'antd'
import { AntdFormItemProps } from '@/common/components/AntdForm/AntdFormItem.tsx'
import { cn } from '@/utils/style.ts'

type AntdFormSectionProps = {
  title?: string
  extra?: React.ReactNode
  children: React.ReactNode
}

const WrapAntdFormItem = (child: React.ReactElement<AntdFormItemProps>) => {
  const { noCol, span } = child.props.fieldProps
  if (noCol) return child
  return <Col span={span || 8}>{child}</Col>
}

export const AntdFormSection: React.FC<AntdFormSectionProps> = ({ title, extra, children }) => {
  return (
    <Row gutter={16}>
      <Col span={24} className="mb-2">
        <Flex justify={title ? 'space-between' : 'flex-end'} align="middle">
          {title ?
            <Typography.Title level={4}>{title}</Typography.Title>
            : null}
          {extra}
        </Flex>
      </Col>
      {React.Children.map(children, (child) => {
        if (child && React.isValidElement<AntdFormItemProps>(child) && child.props.fieldProps) {
          return WrapAntdFormItem(child)
        }
        if (React.isValidElement<{ children: React.ReactNode }>(child) && child.type === React.Fragment) {
          return React.Children.map(child.props.children, (fragmentChild) => {
            if (React.isValidElement<AntdFormItemProps>(fragmentChild) && fragmentChild.props.fieldProps) {
              return WrapAntdFormItem(fragmentChild)
            }
            return fragmentChild
          })
        }
        return child
      })}
    </Row>
  )
}

export const AntdFormSectionWrapper: React.FC<{ children: React.ReactNode }> = (props) => {
  return (
    <Space className="w-full" direction="vertical" size={0} split={<Divider />}>
      {props.children}
    </Space>
  )
}

export const AntdFormWrapper: React.FC<{ children: React.ReactNode, isEdit: boolean }> = (props) => {
  return (
    <div className={cn('bg-gray-100 p-4 rounded-xl w-full', { 'bg-amber-50': props.isEdit })}>
      {props.children}
    </div>
  )
}